export default __webpack_public_path__ + "static/media/illustration.a4272be9.svg";